// extracted by mini-css-extract-plugin
export default {"root":"CancelAttendanceOrClass_root__q9bR5","cancelAttendanceButton":"CancelAttendanceOrClass_cancelAttendanceButton__kk5Tn","cancelBtn":"CancelAttendanceOrClass_cancelBtn__eA9Qa"};